// Input text with Text Field
const InputTextField = ({
  name,
  placeholder,
  disabled,
  onBlur,
  value,
  error,
  type,
  onChange,
  style,
  maxLength,
  autoFocus,
  readOnly = false,
  ...other
}) => {
  return (
    <>
      <>
        <input
          type={type}
          placeholder={placeholder}
          name={name}
          className="form-controlBox"
          disabled={disabled}
          onBlur={onBlur}
          defaultValue={value}
          onChange={onChange}
          style={style}
          maxLength={maxLength}
          autoFocus={autoFocus}
          readOnly={readOnly}
          {...other}
        ></input>
      </>
      <span style={{ color: 'red' }}>{error && <label>{error}</label>}</span>
    </>
  );
};
export default InputTextField;
